var map = {
	"./NU-SLS.jpg": 58,
	"./NU-SLS.png": 59,
	"./blue-dawn.png": 60,
	"./cloud-text-example.png": 61,
	"./cross-for-PDF.png": 62,
	"./cross.png": 63,
	"./di-logo.jpg": 64,
	"./di-logo.png": 65,
	"./freeText/dogs.jpg": 17,
	"./freeText/story-picture.jpg": 18,
	"./freeText/text-message.png": 19,
	"./freeText/water-fight.jpg": 20,
	"./green-tick-for-PDF.png": 66,
	"./green-tick.png": 67,
	"./logo.png": 68,
	"./orange-tick.png": 69,
	"./pink-dawn.png": 70,
	"./practiceSet/baby.jpg": 10,
	"./practiceSet/bell.jpg": 11,
	"./practiceSet/cat.jpg": 12,
	"./practiceSet/mouse.jpg": 13,
	"./practiceSet/shark.jpg": 14,
	"./practiceSet/spider.jpg": 15,
	"./practiceSet/tree.jpg": 16,
	"./setFour/bat.jpg": 71,
	"./setFour/bed.jpg": 72,
	"./setFour/cat.jpg": 73,
	"./setFour/comb.jpg": 74,
	"./setFour/cork.jpg": 75,
	"./setFour/cot.jpg": 76,
	"./setFour/cow.jpg": 77,
	"./setFour/crab.jpg": 78,
	"./setFour/dart.jpg": 79,
	"./setFour/doll.jpg": 80,
	"./setFour/ear.jpg": 81,
	"./setFour/egg.jpg": 82,
	"./setFour/eye.jpg": 83,
	"./setFour/fan.jpg": 84,
	"./setFour/fly.jpg": 85,
	"./setFour/fork.jpg": 86,
	"./setFour/fox.jpg": 87,
	"./setFour/frog.jpg": 88,
	"./setFour/harp.jpg": 89,
	"./setFour/hook.jpg": 90,
	"./setFour/jar.jpg": 91,
	"./setFour/jug.jpg": 92,
	"./setFour/key.jpg": 93,
	"./setFour/kite.jpg": 94,
	"./setFour/lamp.jpg": 95,
	"./setFour/leg.jpg": 96,
	"./setFour/mask.jpg": 97,
	"./setFour/mop.jpg": 98,
	"./setFour/net.jpg": 99,
	"./setFour/owl.jpg": 100,
	"./setFour/pear.jpg": 101,
	"./setFour/pen.jpg": 102,
	"./setFour/rake.jpg": 103,
	"./setFour/shoe.jpg": 104,
	"./setFour/soap.jpg": 105,
	"./setFour/sock.jpg": 106,
	"./setFour/tent.jpg": 107,
	"./setFour/tie.jpg": 108,
	"./setFour/tray.jpg": 109,
	"./setFour/tyre.jpg": 110,
	"./setFour/worm.jpg": 111,
	"./setFour/zip.jpg": 112,
	"./setOne/butterfly.jpg": 113,
	"./setOne/chair.jpg": 114,
	"./setOne/comb.jpg": 115,
	"./setOne/cow.jpg": 116,
	"./setOne/crab.jpg": 117,
	"./setOne/cucumber.jpg": 118,
	"./setOne/ear.jpg": 119,
	"./setOne/egg.jpg": 120,
	"./setOne/fly.jpg": 121,
	"./setOne/fountain.jpg": 122,
	"./setOne/frog.jpg": 123,
	"./setOne/giraffe.jpg": 124,
	"./setOne/horse.jpg": 125,
	"./setOne/jar.jpg": 126,
	"./setOne/key.jpg": 127,
	"./setOne/lemon.jpg": 128,
	"./setOne/magnet.jpg": 129,
	"./setOne/mask.jpg": 130,
	"./setOne/pear.jpg": 131,
	"./setOne/pencil.jpg": 132,
	"./setOne/penguin.jpg": 133,
	"./setOne/saddle.jpg": 134,
	"./setOne/sheep.jpg": 135,
	"./setOne/strawberry.jpg": 136,
	"./setOne/toaster.jpg": 137,
	"./setOne/train.jpg": 138,
	"./setOne/tray.jpg": 139,
	"./setOne/tyre.jpg": 140,
	"./setOne/violin.jpg": 141,
	"./setOne/zip.jpg": 142,
	"./setThree/apple.jpg": 143,
	"./setThree/bat.jpg": 144,
	"./setThree/battery.jpg": 145,
	"./setThree/brain.jpg": 146,
	"./setThree/cactus.jpg": 147,
	"./setThree/cat.jpg": 148,
	"./setThree/coffin.jpg": 149,
	"./setThree/cork.jpg": 150,
	"./setThree/cot.jpg": 151,
	"./setThree/dart.jpg": 152,
	"./setThree/desktop.ini": 153,
	"./setThree/dress.jpg": 154,
	"./setThree/eye.jpg": 155,
	"./setThree/grapes.jpg": 156,
	"./setThree/hammock.jpg": 157,
	"./setThree/house.jpg": 158,
	"./setThree/kite.jpg": 159,
	"./setThree/knife.jpg": 160,
	"./setThree/lamp.jpg": 161,
	"./setThree/lettuce.jpg": 162,
	"./setThree/necklace.jpg": 163,
	"./setThree/net.jpg": 164,
	"./setThree/owl.jpg": 165,
	"./setThree/pineapple.jpg": 166,
	"./setThree/rake.jpg": 167,
	"./setThree/soap.jpg": 168,
	"./setThree/starfish.jpg": 169,
	"./setThree/teapot.jpg": 170,
	"./setThree/tent.jpg": 171,
	"./setThree/tie.jpg": 172,
	"./setThree/wheelchair.jpg": 173,
	"./setTwo/anchor.jpg": 174,
	"./setTwo/bed.jpg": 175,
	"./setTwo/candle.jpg": 176,
	"./setTwo/chain.jpg": 177,
	"./setTwo/clock.jpg": 178,
	"./setTwo/doll.jpg": 179,
	"./setTwo/fan.jpg": 180,
	"./setTwo/feather.jpg": 181,
	"./setTwo/fork.jpg": 182,
	"./setTwo/fox.jpg": 183,
	"./setTwo/grass.jpg": 184,
	"./setTwo/harp.jpg": 185,
	"./setTwo/hook.jpg": 186,
	"./setTwo/jug.jpg": 187,
	"./setTwo/kangaroo.jpg": 188,
	"./setTwo/leg.jpg": 189,
	"./setTwo/microphone.jpg": 190,
	"./setTwo/mop.jpg": 191,
	"./setTwo/pen.jpg": 192,
	"./setTwo/plate.jpg": 193,
	"./setTwo/pumpkin.jpg": 194,
	"./setTwo/scales.jpg": 195,
	"./setTwo/shoe.jpg": 196,
	"./setTwo/skeleton.jpg": 197,
	"./setTwo/slipper.jpg": 198,
	"./setTwo/sock.jpg": 199,
	"./setTwo/table.jpg": 200,
	"./setTwo/telescope.jpg": 201,
	"./setTwo/wallet.jpg": 202,
	"./setTwo/worm.jpg": 203,
	"./shark-example.png": 204,
	"./sundawn.png": 205,
	"./tick.png": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;